"use client";

import { HeroProps } from "@/types/component.types";
import { usePathname } from "next/navigation";
import Headline from "@/components/ui/Headline";
import SectionWrapper from "@/components/ui/SectionWrapper";
import Blobs from "@/components/ui/Blobs";
import Image from "next/image";

export default function Hero({ blok }: { blok: HeroProps }) {

  const pathname = usePathname();
  const segments = pathname.split("/");
  const currentLang = segments[1] && segments[1].length === 2 ? segments[1] : "de";

  return (
    <SectionWrapper
      className="relative min-h-[max(100svh,640px)] md:min-h-[max(100svh,768px)] flex flex-col items-center justify-center text-center px-4 py-8"
      spaces={blok.spaces}
    >
      <Blobs variant="hero" />

      <div className="relative z-10 container flex justify-around items-center xl:flex-row flex-col xl:gap-0 gap-8">
        <div>
          <div className="shrink-0 relative mx-auto w-[240px] md:w-[280px] xl:w-[320px] aspect-[3/4] rounded-[28px] shadow-[3px_3px_8px_5px_rgba(0,0,0,0.15)]">
            <div className="relative w-full h-full rounded-[28px] overflow-hidden border-4 border-beige-dark dark:border-neutral-800 ring-1 ring-black/5 dark:ring-white/5">
              <Image 
                src="/self-portrait-md.webp" 
                alt={currentLang === "de" ? "Ein Portrait von Alexander Dretvic" : "A portrait of Alexander Dretvic"}
                fill
                quality={50}
                priority
                fetchPriority="high"
                sizes="(max-width: 767px) 240px, (max-width: 1277px) 280px, 320px"
                className="object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div>
          <Headline
            className="mb-2"
            text={blok.headline?.[0]?.text}
            level={blok.headline?.[0]?.level}
          />
          
          <Headline
            text={blok.text}
            level="h4"
            tag="h2"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}